import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../store';
import RouterConfig from './router';
import HashScroll from '../components/common/HashScroll';
import AnalyticsPageTracker from '../components/common/AnalyticsPageTracker';
import { BookingDraftProvider } from '../features/booking/BookingDraft';
import '../styles/globals.css';

const App: React.FC = () => {
    return (
        <Provider store={store}>
            <Router>
                <AnalyticsPageTracker />
                <HashScroll />
                {/* The booking draft spans confirm → searching and the card
                    round-trip, so it lives above the router. It holds no state
                    until a booking is started, and none is persisted. */}
                <BookingDraftProvider>
                    <RouterConfig />
                </BookingDraftProvider>
            </Router>
        </Provider>
    );
};

export default App;
